import { DataPoint } from "../../Pages/Live";
import { Chart, DisplayConfig } from "../ViewConfig/ConfigProvider";

export function GenerateTestData(incrementDelta:number, startTime:Date, endTime:Date, tags:string[]):DataPoint[]{
    const testData:DataPoint[] = [];
    let counter = 0
    while (startTime.getTime() < endTime.getTime()){
        tags.forEach(tag=>{
            const value = Math.random()*100+Math.sin(startTime.getTime()/1000000)-50+Math.sin(counter/10)*20
            counter++
            const dp:DataPoint = {
                timestamp:startTime.getTime(),
               
            }
            dp[tag] = value
            testData.push(dp)
        })
        counter=0
        startTime.setSeconds(startTime.getSeconds()+incrementDelta)
    }
    return testData
}

export function getCategoriesFromData(data:DataPoint[]):string[]{
    const categories:Set<string> = new Set()
    data.forEach(dp=>{
        Object.keys(dp).forEach(key=>{
            if (key!=='timestamp'){
                categories.add(key)
            }
        })
    })
    return Array.from(categories)
}

export function dataToMap(data:DataPoint[]):Map<string, {timestamp:number, value:number}[]>{
    const dataMap:Map<string, {timestamp:number, value:number}[]> = new Map()
    data.forEach(dp=>{
        Object.keys(dp).forEach(key=>{
            if (key!=='timestamp'){
                const value = dp[key]
                const timestamp = dp.timestamp
                if (!dataMap.has(key)){
                    dataMap.set(key,[])
                }
                dataMap.get(key)?.push({timestamp,value})
            }
        })
    })
    return dataMap
}

export function filterDataToMap(data:DataPoint[], filter:string[]):Map<string, {timestamp:number, value:number}[]>{
    console.log('filterDataToMap called with filter:',filter)
    const dataMap:Map<string, {timestamp:number, value:number}[]> = new Map()
    data.forEach(dp=>{
        Object.keys(dp).forEach(key=>{
            if (key!=='timestamp' && filter.includes(key)){
                const value = dp[key]
                const timestamp = dp.timestamp
                if (!dataMap.has(key)){
                    dataMap.set(key,[])
                }
                dataMap.get(key)?.push({timestamp,value})
            }
        })
    })
    return dataMap
}

export function CategoriesFromConfig(config:DisplayConfig):string[]{
    const categories:Set<string> = new Set()
    Array.from(config.charts.values()).forEach(chart=>{
        Array.from(chart.categories.values()).forEach(category=>{
            categories.add(category.datakey)
        })
    })
    return Array.from(categories)
}

export function CategoriesFromChart(chart:Chart):string[]{
    const categories:Set<string> = new Set()
    Array.from(chart.categories.values()).forEach(category=>{
        categories.add(category.datakey)
    })
    return Array.from(categories)
}

export function GetValueMinMaxDataPoints(data:DataPoint[], category:string):{min:number, max:number}{
    let min = Number.MAX_VALUE
    let max = Number.MIN_VALUE
    data.forEach(dp=>{
        if (dp[category] !== undefined){
            const value = dp[category]
            if (value < min){
                min = value
            }
            if (value > max){
                max = value
            }
        }
    })
    return {min,max}
}
export function GetCategoryValueMinMaxFromDataMap(data:Map<string, {timestamp:number, value:number}[]>, category:string):{min:number, max:number}{
    let min = Number.MAX_VALUE
    let max = Number.MIN_VALUE
    const values = data.get(category)
    if (values){
        values.forEach(v=>{
            if (v.value < min){
                min = v.value
            }
            if (v.value > max){
                max = v.value
            }
        })
    }
    return {min,max}
}
export interface AxisOptions{
    minScalar?:number,
    maxScalar?:number,}
//function to build value axis from data and options and singular category
export function BuildValueAxis(data:Map<string, {timestamp:number, value:number}[]>, category:string, options:AxisOptions):{min:number, max:number}{
    const {min,max} = GetCategoryValueMinMaxFromDataMap(data, category)
    const minScalar = options.minScalar ?? 0.9
    const maxScalar = options.maxScalar ?? 1.1
    return {min:min*minScalar, max:max*maxScalar}
}

//function to build value axis from data and options and multiple categories, categories are in the data map keys and has been selected before calling this function
export function BuildChartAxis(data:Map<string, {timestamp:number, value:number}[]>, options:AxisOptions):{min:number, max:number}{
    console.log('BuildChartAxis called with data:',data ,' and options:',options)
    let min = Number.MAX_VALUE
    let max = Number.MIN_VALUE
    const categories = Array.from(data.keys())
    categories.forEach(category=>{
        const {min:catMin, max:catMax} = GetCategoryValueMinMaxFromDataMap(data, category)
        if (catMin < min){
            min = catMin
        }
        if (catMax > max){
            max = catMax
        }
    })
    const minScalar = options.minScalar ?? 0.9
    const maxScalar = options.maxScalar ?? 1.1
    return {min:min*minScalar, max:max*maxScalar}
}
